<template>
  <div id="app">
    <keep-alive>
      <router-view v-if="keepalive" />
    </keep-alive>
    <template v-if="!keepalive">
      <router-view />
    </template>
  </div>
</template>
<script>
import Cookies from "js-cookie";
// const ShareImg = require('@/assets/image/shareti.png')
// import wx from "weixin-js-sdk";
// import { createInit } from "@/api/api/wechat";
export default {
  data() {
    return {
      vtime: 0,
    };
  },
  created() {
    this.getInit();
  },
  mounted() { },
  beforeDestroy() { },
  computed: {
    keepalive() {
      return this.$route.meta.keepalive;
    },
  },
  methods: {
    getInit() {
      if (!Cookies.get("token")) return;
      // var url = encodeURIComponent(location.href.split("#")[0]);
      // createInit('/#/login').then((res) => {
      //   console.log(res)
      //   this.url = res.data.shareUrl
      //   wx.config({
      //     debug: false,
      //     appId: res.data.appId,
      //     timestamp: res.data.timestamp,
      //     nonceStr: res.data.nonceStr,
      //     signature: res.data.signature,
      //     jsApiList: [
      //       "onMenuShareTimeline", //自定义“分享给朋友圈”
      //       "onMenuShareAppMessage", //自定义“分享给好友”
      //     ]
      //   })

      //   wx.ready(function () {
      //     // 在这里调用 API
      //     wx.onMenuShareTimeline({
      //       title: "分享到朋友圈赢取现金大奖！", // 分享标题
      //       link: res.data.shareUrl, // 分享链接
      //       imgUrl: ShareImg, // 分享图标
      //       desc: "关注群英荟，赢取属于你的奖金！",
      //       success: function () {
      //         // 用户确认分享后执行的回调函数
      //         alert("成功分享到朋友圈");
      //       },
      //       cancel: function () {
      //         // 用户取消分享后执行的回调函数
      //       }
      //     })
      //     wx.onMenuShareAppMessage({
      //       title: "邀请好友注册赢取现金大奖！", // 分享标题
      //       desc: "关注群英荟，赢取属于你的奖金！", // 分享描述
      //       link: res.data.shareUrl, // 分享链接
      //       imgUrl: ShareImg, // 分享图标
      //       type: "", // 分享类型,music、video或link，不填默认为link
      //       dataUrl: "", // 如果type是music或video，则要提供数据链接，默认为空
      //       success: function () {
      //         // 用户确认分享后执行的回调函数
      //         alert("成功分享给好友");
      //       },
      //       cancel: function () {
      //         // 用户取消分享后执行的回调函数
      //       }
      //     })
      //   })
      // })
    },
  },
};
</script>
<style>
/**
改变边框颜色
 */
.el-table--border,
.el-table--group {
  border: 1px solid #8A8A8A !important;
}

/**
改变表格内竖线颜色
 */
.el-table--border td,
.el-table--border th,
.el-table__body-wrapper .el-table--border.is-scrolling-left~.el-table__fixed {
  border-right: 1px solid #8A8A8A !important;
}

/**
改变表格内行线颜色
 */
.el-table td,
.el-table th.is-leaf {
  border-bottom: 1px solid #8A8A8A !important;
}

.el-table thead tr th {
  border-color: #8c939d;
}

.el-select-dropdown {
  z-index: 5999 !important;
}
.el-table__empty-block {
  height: auto !important;
}
#app {
  height: 100%;
  font-size: 14px;
}

.pos-top {
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;
}

.pos-bottom {
  width: 100%;
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 999;
}

/* 字体为奇数或小数的时候 使用line-height实现字体垂直居中在真机上文字偏上 使用弹性布局解决 */
.fontCenter {
  display: flex;
  align-items: center;
  justify-content: center;
}

.color1 {
  background-color: #ff7a15;
}

.color2 {
  background-color: #099b17;
}

.color3 {
  background-color: #f91400;
}
</style>
